import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountConfigurationComponent } from './component/account-configuration/account-configuration.component';
import { ProjectVisibilityDialogComponent } from './component/create-group-visibility-dialog/project-visibility-dialog.component';
import { AccountConfigurationRoutingModule } from './account-configuration.routes';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { ProjectVisibilityComponent } from './component/project-visibility/project-visibility.component';
import { ProjectVisibilityGroupComponent } from './component/project-visibility-group/project-visibility-group.component';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { AccountConfigurationService } from './services/account-configuration.service';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldControl as MatFormFieldControl, MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MessageDialogModalDialog } from './component/errors-dialog/message-dialog-modal';
import { TranslateModule } from '@ngx-translate/core';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { NotificationService } from './services/notification-service';

@NgModule({
  declarations: [
    AccountConfigurationComponent,
    ProjectVisibilityComponent,
    ProjectVisibilityGroupComponent,
    MessageDialogModalDialog,
    ProjectVisibilityDialogComponent
  ],
  imports: [
    CommonModule,
    AccountConfigurationRoutingModule,
    MatTabsModule,
    MatSelectModule,
    MatRadioModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    TranslateModule,
    MatTableModule,
    MatInputModule
  ],
  providers: [
    AccountConfigurationService,
    NotificationService
  ]
})
export class AccountConfigurationModule { }
